import React from 'react';
import styled, { css } from 'styled-components';

import { CategoriesMobileDisplayOption, RadiusOption } from 'types/graphql';
import { CardProps } from './card.types';
import { ImagePlaceholder } from './image-placeholder';

const radiusOptions = {
  [RadiusOption.rounded]: '9999px',
  [RadiusOption.roundedRectangle]: '12px',
  [RadiusOption.square]: 0,
};

export const StackedCard = ({ radius, mobileDisplay, category, image, isHidden = false }: CardProps): JSX.Element => (
  <Card $mobileDisplay={mobileDisplay} $hidden={isHidden}>
    <ImageWrapper $radius={radius}>{image ? <img src={image} alt='' /> : <ImagePlaceholder />}</ImageWrapper>

    {category}
  </Card>
);

const Card = styled.li<{
  $mobileDisplay: CategoriesMobileDisplayOption;
  $hidden: boolean;
}>`
  align-items: center;
  background: #fff;
  display: flex;
  flex-direction: column;
  font-size: 16px;
  font-weight: 600;
  justify-content: space-between;
  gap: 8px;
  line-height: ${24 / 16};
  min-width: 112px;
  max-width: 180px;
  text-align: center;
  white-space: nowrap;

  ${({ $mobileDisplay, $hidden }) =>
    $mobileDisplay === CategoriesMobileDisplayOption.grid &&
    css`
      flex: 0 0 calc(50% - 6px);
      display: ${$hidden ? 'none' : 'flex'};
    `}
`;

const ImageWrapper = styled.div<{
  $radius: RadiusOption;
}>`
  align-items: center;
  border: 1px solid #e3e7e9;
  border-radius: ${({ $radius }) => radiusOptions[$radius]};
  display: flex;
  height: 112px;
  justify-content: center;
  overflow: hidden;
  width: 112px;

  img {
    display: block;
  }
`;
